import { toast } from "sonner";
import { Eye, Link2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const getLink = async (id) => `${window.location.origin}${(await http.post(`/kits/${id}/preview-link`)).data.path}`;

export const PreviewButtons = ({ kitId, disabled }) => {
  const open = async () => { const w = window.open("", "_blank"); try { w.location = await getLink(kitId); } catch (e) { w.close(); toast.error(errMsg(e)); } };
  const copy = async () => { try { const url = await getLink(kitId); await navigator.clipboard.writeText(url); toast.success("Private preview link copied — anyone with it can view this kit"); } catch (e) { toast.error(errMsg(e)); } };
  const cls = "inline-flex items-center gap-2 rounded-sm border border-[#C9A847] px-4 py-2 text-sm font-semibold text-[#9A7B2C] hover:bg-[#FBF6E9] disabled:opacity-40 transition-colors";
  return (<>
    <button data-testid="view-as-customer" disabled={disabled} onClick={open} className={cls}><Eye size={15} /> View as customer</button>
    <button data-testid="copy-preview-link" disabled={disabled} onClick={copy} className={cls} title="Copy a private preview link"><Link2 size={15} /></button>
  </>);
};
